export default __webpack_public_path__ + "static/media/linkedin.ad1d0bda.svg";